import * as React from 'react';

function SvgAnPromotion(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
            height='1em'
            viewBox='0 0 24 24'
            width='1em'
            className='svg-icon' 
            fill="white"
            {...props}
            >
            <path d="M12 2C8 2 4.5 4 3 7h18c-1.5-3-5-5-9-5zM3 9c.3-1 .8-2 1.5-3h15c.7 1 1.2 2 1.5 3H3z" />
            <path d="M11 9h2v11c0 .6-.4 1-1 1s-1-.4-1-1V9z" />
            <path d="M5 17l-2 4h2l1-2h6l1 2h2l-2-4H5z" />
        </svg>

    );
}

export default SvgAnPromotion;
